import type { Tour } from '../../types';

export const recordsTour: Tour = {
  id: 'institution-records',
  name: 'Records Management Tour',
  description: 'Learn how to manage documents and folders',
  category: 'institution',
  showProgress: true,
  requiredPath: '/records',
  steps: [
    {
      id: 'records-1',
      target: 'records-header',
      title: 'Records Management',
      content: 'This is your central repository for all institutional documents. Organize files in folders, manage versions, and control access.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'records-2',
      target: 'records-toolbar',
      title: 'Action Toolbar',
      content: 'Create new folders, upload documents, and manage bulk actions from this toolbar.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'records-3',
      target: 'records-breadcrumb',
      title: 'Folder Navigation',
      content: 'Navigate through your folder hierarchy using breadcrumbs. Click any level to jump directly there.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'records-4',
      target: 'records-folder-list',
      title: 'Folder Structure',
      content: 'Folders help organize your documents by category, department, or project. Double-click to open a folder.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'records-5',
      target: 'records-document-list',
      title: 'Document List',
      content: 'View all documents in the current folder. Each document shows its classification level, status, and last modified date.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'records-6',
      target: 'records-upload-btn',
      title: 'Upload Documents',
      content: 'Click here to upload new documents. You can drag and drop files or select multiple files at once.',
      position: 'bottom',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
